<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img alt="" src="images/jiadian_shorthight.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>太保家电雇主险短期+24小时-高空</h2>
					<div>行业首选方案 | 中国太平洋产险承保 | 不限厂商品牌</div>

					<p>
						① 灵活投保，可选1-3月方案，适用临时用工
						<br />
						② 人性关怀，扩展24小时意外，非工作意外也保障
						<br />
						③ 保障充足，100/120万方案可选，保障覆盖全面
						<br />
					</p>

					<!--          <div style="margin: 15px 0">-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 灵活投保，可选1-3月方案，适用临时用工<br>-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 人性关怀，扩展24小时意外，非工作意外也保障<br>-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 保障充足，100/120万方案可选，保障覆盖全面<br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 存在安全带免赔特约</span><br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 不含第三者赔偿责任</span><br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 不支持人员批增和替换</span>-->
					<!--          </div>-->
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud
						ref="crud"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<el-row justify="center" type="flex">
						<div style="display: flex; flex-direction: column; margin-bottom: 20px">
							<span class="red-bold">医疗费用：医保范围，含合理必须的自费药，100%赔付。</span>
							<span class="red-bold">误工费：包含住院期间以及出院后的休息误工时间，180天为限。</span>
						</div>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
				<!--        <el-descriptions :column="1" border title="注意事项">-->
				<!--          <el-descriptions-item label="投保年龄">-->
				<!--            投保年龄限16-65周岁-->
				<!--          </el-descriptions-item>-->
				<!--          <el-descriptions-item label="可投保职业">-->
				<!--            本保单被保险人雇员为电梯/商业中央空调安装、运营、维护等（不含制造）相关人员-->
				<!--          </el-descriptions-item>-->
				<!--        </el-descriptions>-->
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="{question = '', answer = ''} in dataQA" :key="question">
								<div>
									<span
										style="
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ question }}</span>
								</div>
								<div style="display: flex; margin-top: 12px">
									<span
										style="
											width: 20px;
											height: 28px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<div v-if="question === '中途是否可以加人？新增人员如何收费？'" style="display: inline-block">
										中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。
										<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
											<tr style="text-align: center">
												<th>剩余月数</th>
												<th v-for="item in 12">{{ item }}个月</th>
											</tr>
											<tr style="text-align: center">
												<td>支付比例</td>
												<td v-for="item in questionDataRate">{{ item }}</td>
											</tr>
										</table>
										保单2021年4月30日24点到期，批增人员2020年5月15日起保按照年度保费的100%收取，若批增人员在6月1日起保按照年度保费的95%收取。
									</div>
									<span v-else style="white-space: pre-wrap">{{ answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<div style="line-height: 26px; white-space: pre-line">
							<span style="font-weight: bold">
								本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪有限公司（以下简称“博维”）进行销售
							</span>
							（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
							太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2022年2季度，公司综合偿付能力充足率225.2%，满足监管要求，最近一期的风险综合评级结果为AA。
							<h3>一、重要告知</h3>
							<span style="font-weight: bold">
								1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。 1.2
								<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
								1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。 1.4
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
								1.5
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
								1.6
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。
								1.7
								保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
							</span>
							<h3>二、产品信息</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">备案名称</th>
									<th style="width: 50%; padding: 5px 0">注册号</th>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">中国太平洋财产保险股份有限公司雇主责任保险（2016版）条款</td>
									<td style="padding: 5px 0">C00001430912016110806772</td>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">中国太平洋财产保险股份有限公司雇主责任保险附加法律费用额外增加条款</td>
									<td style="padding: 5px 0">H00001430922017052494811</td>
								</tr>
							</table>
							<h3>三、产品介绍</h3>
							<h4>3.1 投保人/被保险人</h4>
							售后服务网点（单位）为保险合同的投保人/被保险人。
							<h4>3.2 保险期限</h4>
							自所投保雇主责任保险生效日起，保险期限为一年。
							<h4>3.3 特别约定</h4>
							3.3.1在保险期间内，被保险人的在保雇员因从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）而遭受意外事故，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.3.2本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、法律费用，每项保障项目的赔偿限额以保单载明为准。
							3.3.3本保单的共同被保险人包括保单约定的被保险人及其分销商、二级网点，应在投保时列明在保单中。对于未列明的，在理赔时需要提供与被保险人的相关合作协议、银行结算清单等关系证明材料，如不能提供证明材料的则不视为共同被保险人。
							3.3.4本保单采用记名承保，可承保人员包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表和个体工商户经营者本人。
							3.3.5鉴于被保险人的行业风险特性，本保单所定的保险费率已为最低收费，即短期保费等于保单保费。本保单申请退保可退保费为0，本保单不可进行人员批增、替换和批减。
							3.3.6被保险人须按投保雇员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保雇员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。
							3.3.7
							国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业”。保险人仅对投保高空方案的被保人员承担高处作业的保险责任，投保高空方案的在保雇员从事高处作业发生的保险事故，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.3.8鉴于家电售后移动作业的行业特性，被保险人须在发生保险事故48小时内向保险人报案，且须提供包含派工单位、服务人员、服务时间、用户姓名、联系电话、服务地址等信息在内的不可逆的真实派工记录。否则，保险人有权拒赔或对无法核实保险责任的损失不承担赔偿责任。
							3.3.9被保险人的在保雇员从事高处作业时，因未系挂安全带导致的死亡事故，须免赔10%。
							3.3.10在保险期间内，发生保险责任范围内的保险事故，导致在保雇员死亡或伤残，保险人按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。
							伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家及当地社保部门规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿以死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人应提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。
							3.3.11本保单特约伤残等级赔付限额比例：一级100%；二级90%；三级80%；四级70%；五级60%；六级50%；七级40%；八级30%；九级20%；十级10%。伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。
							3.3.12医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。
							3.3.13医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按100%比例给付医疗保险金。如被保险人或出险人员已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。
							3.3.14自费药品赔付特别约定：本保单在医疗费用项下扩展承保合理且必要的自费药品，保单约定的每人医疗费用责任限额不变。自费药品定义为：除社保甲、乙类用药以外的，合理且必须药品的自费部分，不包括各种营养滋补类的药品、保健品。
							3.3.15误工费赔付特别约定：在保险期间内，发生保险责任范围内的保险事故，导致被保雇员暂时丧失工作能力并住院治疗的事故，经二级（含）以上或保险人认可的医疗机构提供合理的建议休息证明或由保险人依据《人身损害误工期、护理期、营养期评定规范》GA/T
							1193-2014，核定误工天数，保险人按照人民币100元/人/天的标准，以最长180天为限计算误工费。误工费计算包含住院期间以及出院后的休息误工时间，其中出院后休息误工时间取医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据前述第(10)款约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险员工的工资证明。出险员工仅在门诊治疗的，无误工费赔付。
							3.3.16扩展工伤事故：被保险人的在保雇员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。
							3.3.17上下班途中扩展：兹经双方同意，对于被保险人的在保雇员在境内，不包括我国香港、澳门和台湾地区，因工外出期间由于工作原因遭受意外事故及上下班途中遭受意外事故而导致被保险人依法应承担的经济赔偿责任，保险人按照主险条款规定负责赔偿。
							3.3.18扩展法律费用条款：在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
							3.3.19扩展24小时个人意外：在保险期间内，被保险人的在保雇员发生主险条款第五条约定情形以外的意外事故而导致的死亡(或自人身伤害发生之日起在180个日内发生死亡)、伤、残，保险人以主险各保障项目的赔偿限额为限承担赔偿责任。其中，伤残评定标准参照《人身保险伤残评定标准》（中保协发〔2013〕88号）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。本保单所载其他条件均不变。
							除外责任: 本保单对以下原因直接或间接导致被保人员死亡或人身伤害不负赔偿责任：
							(1)战争、战乱、反叛、罢工、暴乱、动乱以及核辐射等； (2)疾病、传染病、生育、怀孕、医疗以及手术等；
							(3)故意自残、自杀以及因药物或酒精导致的犯罪或失常行为； (4)打架、酗酒、吸毒、精神错乱以及高危险运动；
							高危险运动包括但不仅限于： -航空飞行，乘坐民航飞机除外； -使用呼吸器具的潜水活动；
							-足球，以业余身份参加除外； -滑翔运动； -冰上曲棍球； -摩托车竞赛； -登山、攀岩、攀崖； -跳伞；
							-地穴探险； -汽车竞赛； -以运动为职业； -滑水、跳水及水上竞技； -冬季运动，冰上溜石活动和溜冰除外；
							本附加险条款与主险条款内容相悖之处，以本附加险条款为准；未尽之处，以主险条款为准。
							<h4>3.4 保单形式</h4>
							本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
							<h4>3.5 发票形式</h4>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
							<h3>四、理赔</h3>
							出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
							<h3>五、其他信息</h3>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
							5.2
							若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {
	optionBenefit,
	optionPlanJiaDian_short,
	optionPremium,
	optionShortPeriodRate,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product7Details',
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlanJiaDian_short,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			optionShortPeriodRate: optionShortPeriodRate,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '100万',
					plan2: '120万',
				},
				{
					insuredItem: '医疗费用',
					plan1: '20万',
				},
				{
					insuredItem: '误工费用',
					plan1: '100元/天',
				},
				{
					insuredItem: '法律费用',
					plan1: '10万',
				},
				{
					insuredItem: '保费',
				},
				{
					insuredItem: '1个月',
					plan1: '200元/人',
					plan2: '248元/人',
				},
				{
					insuredItem: '2个月',
					plan1: '368元/人',
					plan2: '448元/人',
				},
				{
					insuredItem: '3个月',
					plan1: '552元/人',
					plan2: '672元/人',
				},
				{
					insuredItem: '附加24小时意外保费',
					plan1:
						'扩展承保被保险人的在保人员因个人意外而导致的死亡和伤、残，保险人按照本附加险合同约定在主险各个保障项目的赔偿限额为内承担死亡、伤残、医疗费用及误工费的赔偿责任。',
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '10%',
					level9: '20%',
					level8: '30%',
					level7: '40%',
					level6: '50%',
					level5: '60%',
					level4: '70%',
					level3: '80%',
					level2: '90%',
					level1: '100%',
				},
			],
			dataShortPeriodRate: [
				{
					month1: '30%',
					month2: '40%',
					month3: '50%',
					month4: '55%',
					month5: '60%',
					month6: '70%',
					month7: '75%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
					month12: '100%',
				},
			],
			questionDataRate: ['10%', '20%', '30%', '45%', '50%', '60%', '70%', '80%', '85%', '90%', '95%', '100%'],
			dataQA: [
				{
					question: '雇主责任险的保险公司是哪家？',
					answer: '本雇主责任险产品是由中国太平洋保险股份有限公司承保的。',
				},
				{
					question: '是否有纸质版保单和发票？',
					answer: '保险合同以电子保单形式提供，另外可根据投保单位的需求提供电子发票和纸质专票。',
				},
				{
					question: '保单如何查验真伪？',
					answer:
						'您可以在获取电子保单后登陆中国太平洋保险官网http://www.cpic.com.cn/，点击“服务大厅”-“电子保单验真与下载”-“电子保单验真”选择“上传文件”填入验证码点击验真即可查验。您还可以通过拨打太平洋保险全国客服电话95500进行人工查询。',
				},
				{
					question: '对保障人员有要求吗？',
					answer:
						'只要是单位的雇员，且年龄在16-60周岁之间都可以，可承保人员包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表和个体工商户经营者本人。',
				},
				{
					question: '中途是否可以换人？',
					answer: '在保险有效期内，被替换的员工无出险的前提下，可以替换，无需缴纳保费。',
				},
				{
					question: '中途是否可以加人？新增人员如何收费？',
					answer: '',
				},
				{
					question: '雇主责任险的保障范围有哪些？',
					answer:
						'在保险期间内，被保险人的在保员工在受雇过程中因从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）而遭受意外事故，或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。',
				},
				{
					question: '这个方案是否保障非被保险单位派工造成的第三者损失？',
					answer: '不是的，24小时非单位派工意外仅保障在保人员（雇员）的人身意外，不包含第三者损失。',
				},
				{
					question: '第三者是指哪些人？',
					answer:
						'第三者是指除被保险人及其关联单位和关联人员以外的，被保险人的工作服务对象；或与被保险人、投保人员毫无任何关联关系(包括但不限于亲属、朋友、同事、合作伙伴等关系)的陌生人。',
				},
				{
					question: '什么是“新机完工责任”？',
					answer:
						'网点的工程师提供的家用电器新机首次安装服务存在缺陷、瑕疵或安全隐患，引发意外事故，导致第三者人身伤亡或直接财产损失，依照中华人民共和国法律应由网点承担的经济赔偿责任，保险公司按照本附加险合同约定，在保险合同载明的本附加险责任限额内负责赔偿。',
				},
				{
					question: '新机完工责任保障成立有什么要求？',
					answer:
						'该意外事故发生时间及第三者首次向被保险人提出赔偿的时间均须在新机首次安装完工后的90天内；新机首次安装的人员在保单的保障期内提供新机首次安装服务；必须提供新机首次安装的系统派工单或微信派工记录证明安装时间和安装人员。' +
						'',
				},
				{
					question: '哪些情况不属于第三者责任险（含新机完工责任）的保障范围？',
					answer:
						'1.服务工单机器的损坏；\n' +
						'2.因服务工单机器本身及辅材的产品质量问题导致的第三者人身伤亡及财产损失；\n' +
						'3.冷库、冷却塔，以及非家电范畴的机电设备作业导致的财产损失失；\n' +
						'4.因驾驶各种机动车辆（包括电动车）发生意外事故导致的第三者人身伤亡及财产损失；\n' +
						'5.装卸、运输货物期间发生意外事故导致的第三者人身伤亡及财产损失；\n' +
						'6.第三者直接财产损失不包含第三者要求被保险人赔偿的间接损失，例如交通费、住宿费等；\n' +
						'7.因机器安装维修不合格，导致二次上门服务所产生的机器安装维修费用；以及因安装设计和规范问题（开孔尺寸、安装位置、预留尺寸等）造成吊顶拆装、二次装修、破坏美观、客户退货等间接损失。',
				},
				{
					question: '哪些“特定财产”第三者责任险不负责赔偿？',
					answer:
						'手机、手提电脑、相机等移动数码产品；珠宝、玉器、首饰、古玩、字画、艺术品、收藏品、稀有金属等珍贵财物以及无法鉴定价值的财产；动物、植物。',
				},
				{
					question: '对医疗机构有要求吗？',
					answer:
						'保险公司认可二级或以上的医院治疗，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构；如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入认可的医疗机构就诊。',
				},
				{
					question: '门诊有没有误工费？',
					answer: '仅门诊治疗无误工费补偿。',
				},
				{
					question: '出院后的误工费怎么核算？',
					answer:
						'出院后休息误工时间会根据医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中的最短时间进行核算，误工费是每天100元。',
				},
				{
					question: '造成第三者财产损失怎么赔偿？',
					answer:
						'按照保单特别约定，造成第三者物损每次事故绝对免赔500元。另外，服务工单中本身的机器的损失与特定财产为除外责任，不属于保障范围。',
				},
				{
					question: '造成第三者人伤涉及伤残怎么赔偿？',
					answer: '三者人伤致残没有等级限额。按侵权责任计算相应赔偿金额，但不超过单次事故的三者人伤赔偿限额。',
				},
				{
					question: '第三者财产损失保障中，每次事故财产损失绝对免赔500元是什么意思？',
					answer:
						'简单来说，假如定损金额小于500元，则保险公司最终赔付金额为0元。如果定损金额大于500元，则保险公司赔付金额为定损金额减去500元。',
				},
				{
					question: '非工作期间发生的意外能赔吗？',
					answer: '非工作原因导致的个人意外，例如游泳、戏水、游玩、娱乐和旅行等原因，不属于本方案的保障范围。',
				},
			],
		}
	},
	methods: {
		handleInsure() {
			this.$emit('insure')
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 1 || rowIndex === 2 || rowIndex === 3 || rowIndex === 8) {
				if (columnIndex === 1) {
					return [1, 4]
				}
			}
			if (rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 3]
				}
			}
		},
		onCellStyle({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 5 || rowIndex === 6 || rowIndex === 7) {
				if (columnIndex !== 0) {
					return {
						color: 'red',
						fontWeight: 'bold',
						fontSize: '18px',
					}
				}
			} else if (rowIndex === 4) {
				return {
					background: '#fafafa',
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}
</style>
